export enum GeopointFormat {
  DecimalDegree = 0,
  DegreesMinutesSeconds = 1,
  DegreesDecimalMinutes = 2
}
